export default "__VITE_ASSET__DRXPvub9__"